import type { VisionWidget } from '@/components/VisionAi/widgets/visionWidget.types';

export interface Conversation {
  id: string | number;
  name?: string;
  createdAt: string;
}

export enum ChatMessageRole {
  User = 'user',
  Assistant = 'assistant',
}

export interface ChatMessage {
  id: string | number;
  conversationId?: string | number | null;
  role: ChatMessageRole;
  text: string;
  timestamp: Date;
  intentType?: string;
  intentQuery?: Record<string, unknown> | null;
  additionalContent?: Record<string, unknown> | null;
  feedback?: string | null;
  isWarningMessage?: boolean;
  errorCode?: string | null;
  isLoading?: boolean;
  widgets?: VisionWidget[];
}

/** Vision AI message shape from `visionAiMessagesStore`. */
export interface VisionAiStoreMessage {
  id: string | number;
  serverId?: string | number | null;
  sender: string;
  message?: string | null;
  createdAt: string;
  intentType?: string;
  intentQuery?: Record<string, unknown> | null;
  additionalContent?: Record<string, unknown> | null;
  feedback?: string | null;
  errorCode?: number | string | null;
  isWarningMessage?: boolean;
  conversationId: string | number | null;
}
